// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-content > button {\n  border: none;\n  font-size: 16px;\n}\n\n", ""]);
// Exports
module.exports = exports;
